/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const MailboxInfoStatusEnum = {
    free: 'free',
    paid: 'paid'
};
/**
 * Check if a given object implements the MailboxInfo interface.
 */
export function instanceOfMailboxInfo(value) {
    if (!('address' in value) || value['address'] === undefined)
        return false;
    if (!('provider' in value) || value['provider'] === undefined)
        return false;
    return true;
}
export function MailboxInfoFromJSON(json) {
    return MailboxInfoFromJSONTyped(json, false);
}
export function MailboxInfoFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'address': json['address'],
        'provider': json['provider'],
        'status': json['status'] == null ? undefined : json['status'],
        'verified': json['verified'] == null ? undefined : json['verified'],
    };
}
export function MailboxInfoToJSON(json) {
    return MailboxInfoToJSONTyped(json, false);
}
export function MailboxInfoToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'address': value['address'],
        'provider': value['provider'],
        'status': value['status'],
        'verified': value['verified'],
    };
}
